import { useState, useEffect } from 'react';

const useBrowserOnly = () => {
    const [browserOnly, setBrowserOnly] = useState(false);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            setBrowserOnly(true);
        }
    }, []);
    return browserOnly;
};

export { useBrowserOnly };
//# sourceMappingURL=browserUtils.js.map
